import { motion } from "framer-motion";

const PORTRAIT = "/brand/founder-poster.webp";

const reveal = {
    hidden: { opacity: 0, y: 34 },
    show: { opacity: 1, y: 0, transition: { duration: 0.85, ease: [0.22, 1, 0.36, 1] } },
};

export const Founder = ({ t }) => (
    <section id="about" className="scroll-mt-28 bg-white py-24 md:py-32" data-testid="founder-section">
        <div className="mx-auto grid max-w-[1400px] grid-cols-1 items-center gap-14 px-6 md:px-12 lg:grid-cols-2 lg:gap-20">
            <motion.div
                initial={{ opacity: 0, scale: 0.96 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                className="relative overflow-hidden rounded-[2.5rem] border border-[#E2E8F0] shadow-[0_30px_80px_rgba(5,37,54,0.15)]"
            >
                <img
                    src={PORTRAIT}
                    alt={t.founder.posterAlt}
                    loading="lazy"
                    style={{ aspectRatio: "1086 / 1448" }}
                    className="h-auto w-full object-cover"
                    data-testid="founder-portrait"
                />
            </motion.div>

            <motion.div
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, amount: 0.3 }}
                transition={{ staggerChildren: 0.12 }}
            >
                <motion.p variants={reveal} className="text-xs font-bold uppercase tracking-[0.26em] text-[#0D9488] md:text-sm">
                    {t.founder.overline}
                </motion.p>
                <motion.h2 variants={reveal} className="font-display mt-5 text-4xl leading-tight tracking-tight text-[#0F172A] md:text-5xl">
                    {t.founder.title}
                </motion.h2>
                <motion.blockquote
                    variants={reveal}
                    className="font-display mt-8 border-l-2 border-[#0D9488] pl-6 text-2xl italic leading-relaxed text-[#0E4B57] md:text-3xl"
                    data-testid="founder-quote"
                >
                    “{t.founder.quote}”
                </motion.blockquote>
                <motion.div variants={reveal} className="mt-6">
                    <p className="text-lg font-extrabold text-[#0F172A]" data-testid="founder-name">{t.founder.name}</p>
                    <p className="mt-1 text-xs font-semibold uppercase tracking-[0.18em] text-[#0D9488]" data-testid="founder-role">
                        {t.founder.role}
                    </p>
                </motion.div>
                <motion.p variants={reveal} className="mt-8 max-w-xl text-base leading-relaxed text-[#475569] md:text-lg">
                    {t.founder.body}
                </motion.p>
            </motion.div>
        </div>
    </section>
);
